import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_MULTIPLE_MDS_ASSESSMENT_SUCCESS,
  GET_MULTIPLE_MDS_ASSESSMENT_FAILURE,
  GET_MULTIPLE_MDS_ASSESSMENT_LOADING,
  GET_MULTIPLE_MDS_ASSESSMENT_REQUEST,
  GET_MULTIPLE_MDS_ASSESSMENT_RESET,
} = therapyPlanningAction;

function* getMultipleMdsAssessment(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_MULTIPLE_MDS_ASSESSMENT_LOADING });
    const response = yield call(therapyPlanningService.getMultipleMdsAssessment, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_MULTIPLE_MDS_ASSESSMENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_MULTIPLE_MDS_ASSESSMENT_FAILURE, payload: error });
  }
}

function* getMultipleMdsAssessmentSaga() {
  yield takeEvery(GET_MULTIPLE_MDS_ASSESSMENT_REQUEST, getMultipleMdsAssessment);
}

export default getMultipleMdsAssessmentSaga;
